import { render, staticRenderFns } from "./RecoverConfirm.vue?vue&type=template&id=4b68ddd2&scoped=true&"
import script from "./RecoverConfirm.vue?vue&type=script&lang=js&"
export * from "./RecoverConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RecoverConfirm.vue?vue&type=style&index=0&id=4b68ddd2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68ddd2",
  null
  
)

export default component.exports